<template>
<div class="container">
           
        <table class="datatables-basic table border-bottom" v-if="updates.length > 0">
          <tbody>
            <tr v-for="(update, index) in updates" :key="index.id"> 
            <td class="px-0 py-1">
              <div><b>{{update.user.name+' '+update.user.surname}}</b></div>
              <div><span :class="'badge badge-pill '+update.status" title="Application status">{{update.status}}</span></div>
              <div>{{update.description}}</div>
              <div><timeago :datetime="update.created_at" :auto-update="60"></timeago></div>
              </td>
            </tr>
          </tbody>
        </table>

        <div v-else class="text-center">No updates</div>

</div>

</template> 

<script>
export default {
  props: ["user", "application"], 

  data() {
    return {
      updates: {},
      loading: false,
    };
  },

  mounted() {


  },

  created() {
    
    this.getUpdates();

  },

  methods: {

    getUpdates() {
      
      this.loading = true;

      axios.post("/application/updates", {application_id: this.application.id}).
      then((response) => {
        this.updates = response.data;
        this.loading = false;
      });
    },
    
  }


}
</script>

<style scoped>


</style>